class Contract {
    id = null;
    number = '';
    customer_id = null;
    date_created = null;
    expiration_date = null;
    name = '';
    note = '';
    uploaded_file = {name: '', link: '', id: 0};
    contract_sequence_id = null;
    reminder = false;
    reminder_days = 7;

    constructor(data = {}, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Contract;
